class StickyHeader extends HTMLElement {
  constructor() { 
    super()
  }

  connectedCallback() {
    this.body = document.body
    this.header = document.getElementById('shopify-section-header')
    this.mainHeader = this.header.querySelector('.main-header')
    this.secondaryHeader = this.header.querySelector('.secondary-nav')
    this.headerBounds = {}
    this.currentScrollTop = 0
    this.preventReveal = false
    this.predictiveSearch = this.querySelector('predictive-search')

    this.onScrollHandler = this.onScroll.bind(this)
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    window.addEventListener('scroll', this.onScrollHandler, false)

    this.createObserver()
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this.header)
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return
      requestAnimationFrame(this.hide.bind(this))
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        if (scrollTop < this.lastScrollTop - 200 || scrollTop < 150) requestAnimationFrame(this.reveal.bind(this))
      } else {
        window.clearTimeout(this.isScrolling)

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false
        }, 66)

        requestAnimationFrame(this.hide.bind(this))
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop

    window.clearTimeout(this.scrollChecker)
    this.scrollChecker = setTimeout(() => {
      this.lastScrollTop = scrollTop
    }, 66)
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
    this.header.classList.remove('bg-white')
    this.mainHeader.classList.add('opacity-0')
    this.mainHeader.classList.remove('opacity-100')
    this.closeMenuDisclosure()
    this.closeSearchModal()

    if (this.secondaryHeader) this.secondaryHeader.style.transform = `translateY(-${this.mainHeader.offsetHeight}px)`
    this.mainHeader.style.transform = `translateY(-${this.mainHeader.offsetHeight}px)`
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky')
    this.mainHeader.classList.add('bg-white', 'opacity-100')
    this.mainHeader.classList.remove('opacity-0')
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-static')
    if (this.secondaryHeader) this.secondaryHeader.style.transform = 'none'
    this.mainHeader.style.transform = 'none'
  }

  reset() {
    if (!location.href.includes('/products/build-your-own-proxy')) {
      this.header.classList.add('shopify-section-header-static')
      this.mainHeader.classList.add('opacity-100')
      this.mainHeader.classList.remove('bg-white', 'opacity-0')
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky')
      if (this.secondaryHeader) this.secondaryHeader.style.transform = 'none'
      this.mainHeader.style.transform = 'none'
    } else {
      this.mainHeader.classList.add('opacity-0')
      this.mainHeader.classList.remove('opacity-100')
      this.mainHeader.style.transform = `translateY(-${this.mainHeader.offsetHeight}px)`
    }
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu')
    this.disclosures.forEach((disclosure) => disclosure.close())
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal')
    if (this.searchModal) this.searchModal.close(false)
  }
}

customElements.define('sticky-header', StickyHeader)

// Mega menu video
const products = document.querySelectorAll('.megamenu .product.hover')
let posterTime = -1

products.forEach((product) => {
  const image = product.querySelector('img')
  const video = product.querySelector('video')
  product.addEventListener('mouseover', () => {
    product.classList.add('text-white')
    image.classList.add('hidden')
    video.classList.remove('invisible', 'opacity-0')
    video.classList.add('opacity-1')
    posterTime = video.currentTime //# set time
    video.currentTime = 0
    video.play()
  })

  product.addEventListener('mouseout', () => {
    product.classList.remove('text-white')
    image.classList.remove('hidden')
    video.classList.add('visible', 'opacity-1')
    video.classList.add('opacity-0')
    video.currentTime = posterTime //# get time
  })
})

const secondaryNav = document.querySelector('[data-secondary-nav]')
if (secondaryNav) {
  const itemText = secondaryNav.querySelector('[data-item-text]')
  const secondItems = secondaryNav.querySelectorAll('[data-menu-item]')
  secondItems.forEach((secondItem) => {
    secondItem.addEventListener('click', () => {
      secondItems.forEach((item) => {
        if (item == secondItem) {
          item.classList.add('order-[-1]', 'border-white')
          item.classList.remove('border-puffco-grey-2')
          itemText.innerHTML = item.querySelector('a').innerHTML
        } else {
          item.classList.remove('order-[-1]', 'border-white')
          item.classList.add('border-puffco-grey-2')
        }
      })
    })
  })
}

const headerLinks = document.querySelectorAll('.section-header a[href]')
if (headerLinks.length > 0) {
  headerLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const url = e.target.tagName == 'A' ? e.target.href : e.target.closest('a')
      if (url[0] === '#' && url.length > 1) {
        const targetElement = document.querySelector(url)
        if (targetElement) targetElement.scrollIntoView({ behavior: 'smooth' })
      }
    })
  })
}

// Change secondary nav text on scroll
class InViewportObserver {
  constructor(menuLinks) {
    this.menuLinks = menuLinks
    this.observer = new IntersectionObserver(this.onIntersection, {
      threshold: 0.0,
    })

    this.init()
  }

  init() {
    const divElements = document.querySelectorAll('div')

    divElements.forEach((div) => {
      this.observer.observe(div)
    })
  }

  onIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.checkLinkInnerHTMLMatch(entry.target.id)
      }
    })
  }

  checkLinkInnerHTMLMatch(divId) {
    let matchFound = false
    let matchedMenuText = ''

    this.menuLinks.forEach((link) => {
      const linkWords = link.innerHTML.toLowerCase().split(/[\s_-]+/)
      const divIdWords = divId.toLowerCase().split(/[\s_-]+/)

      linkWords.forEach((linkWord) => {
        if (divIdWords.includes(linkWord)) {
          matchFound = true
          matchedMenuText = link.innerHTML
        }
      })
    })

    if (matchFound) {
      const spanElement = document.querySelector('.menu-secondary--title.w-full')
      if (spanElement) {
        spanElement.innerHTML = matchedMenuText
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const menuList = document.getElementById('HeaderMenu-MenuList-1')
  const menuLinks = menuList ? menuList.querySelectorAll('li a') : []
  new InViewportObserver(menuLinks)
})

// Anchor links - scroll up by 5% of the view height
function getScrollPosition(el) {
  return el.getBoundingClientRect().top
}
window.addEventListener('scroll', function () {
  const hash = window.location.hash
  if (hash) {
    const section = document.querySelector(hash)
    if (section) {
      const position = getScrollPosition(section)
      if (position >= 0 && position <= 5) {
        window.scrollTo(0, window.scrollY - window.innerHeight * 0.1)
      }
    }
  }
})

const menuElement = document.querySelector('.menuspan')
const hamburger = document.querySelector('.hamburger')
const backButton = document.querySelector('backbtn')

if (menuElement) {
  menuElement.addEventListener('click', () => {
    document.querySelector('.section-header').style.display = 'block'
    if (backButton) {
      backButton.style.display = 'none'
    }
  })
}

if (hamburger) {
  hamburger.addEventListener('click', () => {
    document.querySelector('.section-header').style.display = 'block'
    if (backButton) {
      backButton.style.display = 'none'
    }
  })
}
